import { DependencyList, useCallback, useRef } from 'react'

export function useSerializedCallback<T extends () => Promise<any>>(
  callback: T,
  deps: DependencyList
): T {
  const promiseRef = useRef<Promise<any> | null>(null)

  return useCallback(async (...args: any) => {
    if (promiseRef.current) {
      return promiseRef.current
    }

    promiseRef.current = (callback as any)(...args)

    try {
      return await promiseRef.current
    } finally {
      promiseRef.current = null
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps) as unknown as T
}
